import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSitesQuery = createQueryHook(ShopRendererApiClient.getSites, {
  queryKey: ['sites'],
})
